module.exports = __webpack_public_path__ + "media/images/icons/phone-3e9ff63509c1681596f6997d0e672264.svg";